/**
 * Obtém o CNPJ da empresa do elemento com o ID "minha_empresa_cnpj" na página.
 *
 * @returns {string|null} O CNPJ da empresa ou null se o elemento não for encontrado.
 */
function getEmpresaCNPJ() {
  const element = document.getElementById("minha_empresa_cnpj");
  if (element) {
    const textContent = element.textContent;
    const replacedText = textContent.replace(/E/gi, "");
    return replacedText;
  } else {
    return null;
  }
}

/**
 * Obtém o UID da empresa do elemento com o ID "minha_empresa_uid" na página.
 *
 * @returns {string|null} O UID da empresa ou null se o elemento não for encontrado.
 */
function getEmpresaUid() {
  const element = document.getElementById("minha_empresa_uid");
  if (element) {
    const textContent = element.textContent;
    return textContent;
  } else {
    return null;
  }
}

/**
 * Obtém o UID do usuário do elemento com o ID "user_guid" na página.
 *
 * @returns {string|null} O UID do usuário ou null se o elemento não for encontrado.
 */
function getUsuarioUID() {
  const element = document.getElementById("user_guid");
  if (element) {
    const textContent = element.textContent;
    return textContent;
  } else {
    return null;
  }
}

/**
 * Obtém a URL base do elemento com o ID "baseUrl" na página.
 *
 * @returns {string|null} A URL base ou null se o elemento não for encontrado.
 */
function getBaseUrl() {
  const element = document.getElementById("baseUrl");
  if (element) {
    const textContent = element.textContent;
    return textContent;
  } else {
    return null;
  }
}

/**
 * Obtém o número de WhatsApp do elemento com o ID "orangiuz_whatsapp" na página.
 *
 * @returns {string|null} O número de WhatsApp ou null se o elemento não for encontrado.
 */
function getOrangiuzWhatsApp() {
  const element = document.getElementById("orangiuz_whatsapp");
  if (element) {
    const textContent = element.textContent;
    return textContent;
  } else {
    return null;
  }
}

const GetDataHelper = {
  getEmpresaCNPJ,
  getUsuarioUID,
  getBaseUrl,
  getEmpresaUid,
  getOrangiuzWhatsApp,
};
export default GetDataHelper;
